__turbopack_context__.v({
  "ArrowBoxButton": "ArrowBoxButton-module__0cob5q__ArrowBoxButton",
  "icon": "ArrowBoxButton-module__0cob5q__icon",
  "iconright": "ArrowBoxButton-module__0cob5q__iconright",
});
